
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { harajukuUrthcafeTopImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { meta as pancakePageMeta } from "./pancake.mdx";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
export const meta = {
  path: "/media/harajuku/urthcafe",
  title: "【セレブ御用達】LAで行列ができる表参道アースカフェ(Urth Caffe)でふわふわパンケーキを食べよう！",
  description: "LAで行列ができるほどの人気のカフェが、表参道アースカフェ(Urth Caffe)。ふわふわのオリジナルオーガニックパンケーキをはじめとして、コーヒーやボバなど、他の店では体験できない食事ができます！そんな表参道のパンケーキ有名店のアースカフェ(Urth Caffe)についてご紹介させていただきます。",
  topImg: harajukuUrthcafeTopImage,
  author: murakamiMasanori,
  tags: ["表参道", "カフェ", "有名店", "行列店", "パンケーキ", "おしゃれな内装", "人気店", "お店の紹介", "デート", "女子会", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`LA で行列ができるほどの人気で、ハリウッドスターやセレブも御用達のカフェが、表参道にも数年前にオープンしました。`}</p>
    <p>{`それが、アースカフェ(Urth Caffe)。ふわふわのオリジナルオーガニックパンケーキも、４種類のパンケーキがあり、オーガニックメニューが楽しめるようになっています。たくさんの女性がおガーニック食材やインスタ映えスポットを求めて集まり、いつも行列。`}</p>
    <p>{`そんな表参道のパンケーキ有名店のアースカフェ(Urth Caffe)についてご紹介させていただきます。`}</p>
    <hr></hr>
    <h2>{`ロサンゼルスで行列ができる超人気のパンケーキカフェ`}</h2>
    <p>{`アメリカ・カリフォルニア州では、7 店舗を展開しているお店で、ジャスティン・ビーバーやマイリー・サイラスなど、芸能人御用達の人気店になっています。
アースカフェ(Urth Caffe)の人気の秘密は、`}<strong parentName="p">{`オーガニック食材`}</strong>{`にあります。`}</p>
    <p>{`卵や乳製品なども一切使わないビーガン料理もあり、ヘルシー嗜好のアメリカ人たちに大人気。
ご紹介するパンケーキも、オーガニック食材をしたものになっておりますので、後ほどご紹介させていただきます！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <h3>{`アースカフェ(Urth Caffe) は表参道から徒歩３分`}</h3>
    <p>{`アースカフェ(Urth Caffe)は表参道から徒歩３分の好立地にあり、こんな外観をしているので、すぐに見つけられると思います！
開放的でまさに海外のカフェのようですよね！`}</p>
    <InstaImage postId="Bv1Z3DAArTV" mdxType="InstaImage" />
    <h3>{`インスタ映えスポット`}</h3>
    <p>{`アースカフェ(Urth Caffe)はテラス席にたくさんのインスタ映えスポットがあります！
パンケーキはもちろんのこと、`}<strong parentName="p">{`ボバ(タピオカのような透明度の高い粒)`}</strong>{`も人気で、ボバと一緒に写真を撮ったり、背景にして友達と写真を撮ったりして楽しむこともできます！`}</p>
    <p>{`アースカフェ(Urth Caffe)にお越しの際には、インスタ映えの写真を撮ってみましょう！`}</p>
    <InstaImage postId="BmlR3smAXRt" mdxType="InstaImage" />
    <InstaImage postId="BwCeGq6hztT" mdxType="InstaImage" />
    <InstaImage postId="BvUQZnOAdlT" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`人気のパンケーキ４選`}</h2>
    <p>{`アースカフェ(Urth Caffe)では、オーガニック食材で作るパンケーキを提供。
パンケーキとオーガニックコーヒー、パンケーキとオーガニックボバなど、いろんな楽しみ方ができる人気のパンケーキを 4 つご紹介させていただきます。`}</p>
    <h3>{`パンケーキ(1,278 円)`}</h3>
    <InstaImage postId="B9qTrR_AaAd" mdxType="InstaImage" />
    <p>{`極厚でふわふわな外観をしたパンケーキの真ん中はハート型になっているので、つい写真を撮りたくなってしまいます！
焼き上がりから 10 分間がふわふわな食感を 1 番楽しめる時間になっているそうなので、到着したらできるだけ早く食べてみてください。`}</p>
    <h3>{`オーガニックコーヒー パンケーキ(1,500 円)`}</h3>
    <InstaImage postId="B0IJw20JblE" mdxType="InstaImage" />
    <p>{`アースカフェ (Urth Caffe)が 100％化学肥料・化学物質を使わずオーガニック栽培で育てた安全なコーヒーで作るパンケーキ！
見た目よりも甘さ控えめで食べられるそうです。`}</p>
    <p>{`オーガニック食材なので、食べても地球に優しいのは素敵ですよね。`}</p>
    <h3>{`イチゴ マスカルポーネ パンケーキ(1,500 円)`}</h3>
    <InstaImage postId="BxMTk_aFiwl" disableCarousel mdxType="InstaImage" />
    <p>{`マスカルポーネがたっぷりかかったアースカフェ(Urth Caffe)の人気メニューで、他のお店では中々食べられないアースカフェ(Urth Caffe)オリジナルのパンケーキ！
インスタに写真をあげたくなるようなどっさりとしたクリームとパンケーキが、食欲をそそりますよね！`}</p>
    <h3>{`オーガニック抹茶 マスカルポーネ パンケーキ(1,500 円)`}</h3>
    <InstaImage postId="BiJWwKrFPx4" mdxType="InstaImage" />
    <p>{`抹茶好きにはたまらないパンケーキで、甘さも控えめで食べやすいそうです！
こちらもオーガニック食材を使ったものになりますので、体にも地球にも優しい食材になっています！`}</p>
    <h3>{`パンケーキと一緒に楽しめる特製ボバ`}</h3>
    <p>{`アースカフェ(Urth Caffe)は`}<strong parentName="p">{`ボバ(タピオカのような透明度の高い粒)`}</strong>{`が人気で、こちらもオーガニック食材で作れらています。
グリーンティー、アールグレイ、スパイスチャイなど数多くの種類から選べ、パンケーキのお供にいかがでしょうか！？`}</p>
    <InstaImage postId="BUmQ27DlHBm" mdxType="InstaImage" />
    <InstaImage postId="B-Hdgp3jxbP" mdxType="InstaImage" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`LA で行列ができる店アースカフェ(Urth Caffe)をご紹介させていただきましたが、いかがでしたでしょうか！？
アースカフェ(Urth Caffe)のインスタ映えのスポットで、オリジナルのパンケーキ、コーヒー、ボバを召し上がってください！`}</p>
    <hr></hr>
    <p>{`他の原宿のパンケーキが気になる方は、この記事がオススメ！`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;